module.exports = __webpack_public_path__ + "img/13.d8df269c.jpg";